import { getType } from 'typesafe-actions'

import { withLoadingReducer } from '../loading'

import { ProductsActions } from './actions'
import { ProductsState } from './types'

export const initialState: ProductsState = {
  products: []
}

export const reducer = (state: ProductsState = initialState, action: ProductsActions): ProductsState => {
  switch (action.type) {
    case getType(ProductsActions.setLoadedProducts): {
      const { payload } = action
      return {
        ...state,
        products: payload.products
      }
    }
    default:
      return state
  }
}

export const productsReducer = withLoadingReducer(reducer, 'products', initialState)
